import React from "react";
import { CRITICALITY, STATUS, SEVERITY, VULN_STATUS, THREAT_STATUS } from "@/lib/api";

export function CritBadge({ value }) {
  const c = CRITICALITY[value] || CRITICALITY.low;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-sm border text-xs font-medium ${c.cls}`}
      data-testid={`crit-badge-${value}`}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: c.dot }} />
      {c.label}
    </span>
  );
}

export function StatusBadge({ value }) {
  const s = STATUS[value] || STATUS.planned;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-sm border text-xs font-medium ${s.cls}`}>
      {s.label}
    </span>
  );
}

export function SevBadge({ value }) {
  const s = SEVERITY[value] || SEVERITY.UNKNOWN;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-sm border text-xs font-medium ${s.cls}`}
      data-testid={`sev-badge-${value}`}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: s.dot }} />
      {s.label}
    </span>
  );
}

export function VulnStatusBadge({ value }) {
  const s = VULN_STATUS[value] || VULN_STATUS.OPEN;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-sm border text-xs font-medium ${s.cls}`}
      data-testid={`vuln-status-badge-${value}`}
    >
      {s.label}
    </span>
  );
}

export function ThreatStatusBadge({ value }) {
  const s = THREAT_STATUS[value] || THREAT_STATUS.ACTIVE;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-sm border text-xs font-medium ${s.cls}`}
      data-testid={`threat-status-badge-${value}`}
    >
      {s.label}
    </span>
  );
}

export function EmptyState({ icon: Icon, title, hint, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center border border-dashed border-border rounded-sm">
      {Icon && <Icon className="h-10 w-10 text-muted-foreground mb-4" aria-hidden="true" />}
      <p className="font-head text-lg font-semibold">{title}</p>
      {hint && <p className="text-sm text-muted-foreground mt-1 max-w-sm">{hint}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
